$(document).ready(function () {
    $(".product-name input").change(function(){
       var value = $( "input[type=radio][name=Color]:checked" ).val();
       $( "#Colour" ).val( value );
    });
    lightbox.option({
      'resizeDuration': 200,
      'disableScrolling': true,
      'wrapAround': true
    })
  $(".slider-reviews").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
  });
  $(".tab-gallery").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $('[data-tab="tab-gallery"]').click(function(){
    $('.tab-gallery').slick('refresh');
  });
  $('.tab-gallery').slickLightbox({
    itemSelector        : 'a',
    navigateByKeyboard  : true
  });  
  $("ul.shopify-tabs > li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $(this).parent().find("li").removeClass("current");
    $(".shopify-tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });
});
